import script from "./PageOrganizationHouseTechMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PageOrganizationHouseTechMap.vue?vue&type=script&setup=true&lang=js"

import "./PageOrganizationHouseTechMap.vue?vue&type=style&index=0&id=ad0774b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0774b0"]])

export default __exports__